<template>
    <div>
        <br>
        <button @click="obtenerBoletas" class="btn btn-info"
            v-if="$router.currentRoute.name == 'ventasEvento'">Actualizar Número Participantes</button>
        <br><br>
        <v-card-title class="title font-weight-bold mx-0 px-0" >Datos Participantes
                  
        </v-card-title>
        <v-expansion-panels focusable v-model="panel"  @change="changeTab" class="st-tab">
            <v-expansion-panel v-for="(item, index) in productos.length" :key="index" class="st-tab">
                <v-expansion-panel-header>Participante {{ index + 1 }}</v-expansion-panel-header>
                <v-expansion-panel-content>

                    <!-- Mostrando contenido de la pestaña: {{ tab }} -->

                    <form @submit.prevent="saveParticipante(tab)">
                        <div class="form-row">
                            <!-- Sección 1: Datos Personales -->
                            <v-col cols="12">
                                <v-subheader>Datos Personales</v-subheader>
                                <v-divider></v-divider>
                            </v-col>

                            <v-col cols="12" class="form-group">
                                <label class="mb-4 font-weight-bold" for="inputNombre">Nombre Completo</label>
                                <v-text-field solo placeholder="Ingrese su nombre" type="text" id="inputNombre"
                                    v-model="datos_depurado[tab].nombre" required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <label class="mb-4 font-weight-bold" for="inputCorreo">Correo Electrónico</label>
                                <v-text-field solo placeholder="correo@ejemplo.com" type="email" id="inputCorreo"
                                    v-model="datos_depurado[tab].email" required />
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="mb-4 font-weight-bold" for="inputCedula">Cedula de Ciudadanía</label>
                                <v-text-field type="number" solo id="inputCedula" placeholder="Ingrese su cédula"
                                    v-model="datos_depurado[tab].documento" required />
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="mb-4 font-weight-bold" for="inputFechaNacimiento">Fecha de
                                    Nacimiento</label>
                                <v-text-field type="date" solo id="inputFechaNacimiento"
                                    v-model="datos_depurado[tab].fecha_nacimiento" required />
                            </v-col>
                            <v-col>
                                <label class="mb-4 font-weight-bold" for="inputTalla">Talla de Camiseta</label>
                                <v-select solo id="inputTalla" label="Talla de Camiseta"
                                    v-model="datos_depurado[tab].talla_camiseta"
                                    :items="['XS', 'S', 'M', 'L', 'XL', 'XXL']" placeholder="Escoja su Talla..."
                                    required></v-select>
                            </v-col>

                            <!-- Sección 2: Información Médica y de Contacto -->
                            <v-col cols="12">
                                <v-subheader>Información Médica y de Contacto</v-subheader>
                                <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" md="6" class="form-group ">
                                <label class="mb-4 font-weight-bold" for="inputEPS">EPS</label>
                                <v-text-field type="text" solo placeholder="Ingrese su EPS" id="inputEPS"
                                    v-model="datos_depurado[tab].eps" required />
                            </v-col>
                            <v-col cols="12" md="6" class="form-group">
                                <label class="mb-4 font-weight-bold" for="inputRH">RH</label>
                                <v-select id="inputRH" solo label="RH" v-model="datos_depurado[tab].rh"
                                    :items="['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']"
                                    placeholder="Seleccione su RH..." required></v-select>
                            </v-col>
                            <div class="form-group col-md-7">
                                <label class="mb-4 font-weight-bold" for="inputContEmer">Contacto de Emergencia</label>
                                <v-text-field type="text" placeholder="Nombre de contacto" solo id="inputContEmer"
                                    v-model="datos_depurado[tab].contacto" required />
                            </div>
                            <div class="form-group col-md-5">
                                <label class="mb-4 font-weight-bold" for="inputNumeroCont">Número de Contacto</label>
                                <v-text-field type="number" placeholder="Ingrese el número de contacto" solo id="inputNumeroCont"
                                    v-model="datos_depurado[tab].num_contacto" required />
                            </div>
                            <div class="form-group col-md-12">
                                <label class="mb-4 font-weight-bold" for="inputParentesco">Parentesco</label>
                                <v-text-field type="text"  solo placeholder="Ingrese parentesco" id="inputParentesco"
                                    v-model="datos_depurado[tab].parentesco" required />
                            </div>
                        </div>


                        <div class="form-group" style="text-align: left;"
                            v-if="$router.currentRoute.name != 'ventasEvento'">
                            <div class="form-check mp2">
                                <input class="form-check-input" type="checkbox" id="gridCheck"
                                    v-model="datos_depurado[tab].politica_uno" required>
                                <label class="form-check-label" for="gridCheck">
                                    ACEPTO LA DECLARACIÓN DE EXONERACIÓN DE RESPONSABILIDADES Y ACEPTACIÓN DE TÉRMINOS
                                    DE
                                    PARTICIPACIÓN Y EL REGLAMENTO DE LA COMPETENCIA.
                                </label>
                            </div><br>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="gridCheck"
                                    v-model="datos_depurado[tab].politica_dos" required>
                                <label class="form-check-label" for="gridCheck">
                                    ACEPTO la política de privacidad.
                                </label>
                            </div><br>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="gridCheck"
                                    v-model="datos_depurado[tab].politica_tres" required>
                                <label class="form-check-label" for="gridCheck">
                                    ACEPTO LA POLÍTICA DE ENTREGA DE CAMISETAS: La organización ha previsto un rango
                                    amplio
                                    de tallas, sin embargo, no garantiza la disponibilidad del 100% de las mismas y
                                    están
                                    sujetas a inventario.
                                </label>
                            </div><br>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="gridCheck"
                                    v-model="datos_depurado[tab].politica_cuatro" required>
                                <label class="form-check-label" for="gridCheck">
                                    ACEPTO LA POLÍTICA DE ENTREGA DE KITS: Confirmas y declaras que has leído, entendido
                                    y
                                    aceptas íntegramente la declaración de exoneración de responsabilidades y términos
                                    de
                                    participación.
                                </label>
                            </div>
                        </div>
                        <v-divider></v-divider>



                        <v-btn block rounded large type="submit" class="primary">Guardar Datos Participante {{ index +
                            1 }}
                        </v-btn>

                    </form>

                    <!-- {{ datos_depurado }} -->


                </v-expansion-panel-content>
            </v-expansion-panel>


        </v-expansion-panels>


    </div>
</template>

<script>

export default {
    panel: [],
    name: 'Participantes',
    props: ['informacion'],
    data() {
        return {
            tab: 0,
            productos: [],
            datos_depurado: [],
        };
    },
    created() {
        this.obtenerBoletas()
    },
    methods: {

        saveParticipante(tab) {

            this.datos_depurado = this.datos_depurado.filter((valor, indice, self) =>
                indice === self.findIndex(obj => (
                    obj.id_boleta === valor.id_boleta
                ))
            );

            localStorage.setItem('mantenerParticipantes', JSON.stringify(this.datos_depurado))
            swal("¡Bien Hecho!", "Datos guardados correctamente.", "success");
        },
        changeTab(tab) {
            this.tab = tab
        },
        obtenerBoletas() {
            // if(this.$router.currentRoute.name == 'ventasEvento') {

            var data = JSON.parse(localStorage.getItem('boletasReservadasPV'))

            // } else {
            //     var data = localStorage.getItem('newboletasclear')  
            // }              

            if (data) {

                console.log(data)

                this.$router.currentRoute.name == 'ventasEvento' ? this.productos = data : this.productos = data

                if (localStorage.getItem('mantenerParticipantes')) {

                    this.datos_depurado = JSON.parse(localStorage.getItem('mantenerParticipantes'))

                    this.productos.forEach((item, indice) => {

                        try {

                            if (this.datos_depurado[indice].id_boleta === item) {
                                console.log("ok")
                            } else {
                                throw new Error(item);
                            }

                        } catch (error) {

                            this.datos_depurado.push(
                                {
                                    id_boleta: item,
                                    nombre: '',
                                    email: '',
                                    documento: '',
                                    fecha_nacimiento: '',
                                    talla_camiseta: '',
                                    contacto: '',
                                    num_contacto: '',
                                    parentesco: '',
                                    eps: '',
                                    rh: '',
                                    politica_uno: false,
                                    politica_dos: false,
                                    politica_tres: false,
                                    politica_cuatro: false,
                                    id_venta: 0
                                }
                            )

                        }

                    })



                    if (this.datos_depurado[this.tab].id_boleta === 0) {
                        this.datos_depurado.push(
                            {
                                id_boleta: item,
                                nombre: '',
                                email: '',
                                documento: '',
                                fecha_nacimiento: '',
                                talla_camiseta: '',
                                contacto: '',
                                num_contacto: '',
                                parentesco: '',
                                eps: '',
                                rh: '',
                                politica_uno: false,
                                politica_dos: false,
                                politica_tres: false,
                                politica_cuatro: false,
                                id_venta: 0
                            }
                        )
                        localStorage.setItem('mantenerParticipantes', JSON.stringify(this.datos_depurado))
                    }

                } else {
                    this.productos.forEach(item => {
                        this.datos_depurado.push(
                            {
                                id_boleta: item,
                                nombre: '',
                                email: '',
                                documento: '',
                                fecha_nacimiento: '',
                                talla_camiseta: '',
                                contacto: '',
                                num_contacto: '',
                                parentesco: '',
                                eps: '',
                                rh: '',
                                politica_uno: false,
                                politica_dos: false,
                                politica_tres: false,
                                politica_cuatro: false,
                                id_venta: 0
                            }
                        )
                    });
                }

            }
        }
    }
};
</script>
<style>
.st-tab {

    /* border-bottom: 1px #BC244A solid !important; */
    border: none !important;

}
</style>